import Layout from "@/views/layout";

const exwarehouse = {
  path: "/exwarehouse",
  name: "exwarehouse",
  component: Layout,
  meta: {
    title: "扫码出库"
  },
  children: [{
      path: "sweecode",
      name: "SweeCode",
      component: () => import("@/views/exwarehouse/index"),
      meta: {
        title: "扫码出库"
      }
    },
    {
      path: "scan",
      name: "Scan",
      component: () => import("@/views/exwarehouse/scan"),
      meta: {
        title: "扫码出库"
      }
    },
    {
      path: "scanPreview",
      name: "ScanPreview",
      component: () => import("@/views/exwarehouse/scanPreview"),
      meta: {
        title: "扫码预览"
      }
    }
  ]
};

export default exwarehouse;